const config = {
  VERSION: process.env.VERSION,
  SERVER_API_URL: process.env.SERVER_API_URL,
  ASIAPAY_URL: process.env.ASIAPAY_URL,
  ASIAPAY_MERCHANT_ID: process.env.ASIAPAY_MERCHANT_ID
};

export default config;

// export const SERVER_API_URL = ':8080';
export const SERVER_API_URL = config.SERVER_API_URL;
export const ASIAPAY_URL = config.ASIAPAY_URL;
export const ASIAPAY_MERCHANT_ID = config.ASIAPAY_MERCHANT_ID;

export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER'
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error'
};

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD-MM-YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'll';
export const APP_LOCAL_TIME_FORMAT_ALL = 'YYYY-MM-DD hh:mm';
export const APP_LOCAL_DATE_ONLY_FORMAT = 'YYYY/MM/DD';
export const APP_LOCAL_TIME_FORMAT_WITH_MIN = 'Ah時m分';
export const APP_LOCAL_TIME_FORMAT = 'Ah時';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDThh:mm';
export const APP_LOCAL_DATE_FOR_PROMOTION = 'MMDD';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';
